import { createSafeContext } from "@/hooks/safeContext";
import { OrgUserPrivate, UserPrivate } from "@/viaduct-api";

interface UserContextType {
  user: UserPrivate;
  orgUser: OrgUserPrivate;
}

export const [useUser, UserContext] = createSafeContext<UserContextType>();
